import React from "react";
import styles from "./styles";
import { connect } from "react-redux";
import { compose } from "recompose";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import CardActions from "@material-ui/core/CardActions";
// import mapImg from '../../assets/images/mapImg.png'
import { Typography } from "@material-ui/core";

class ShowingCard extends React.Component {
  address = data => {
    let addressField = "";
    let street = data.street_number ? data.street_number + " " : "";
    let route = data.route ? data.route + ", " : "";
    let city = data.city ? data.city + ", " : "";
    let state = data.state ? data.state + ", " : "";
    let zip = data.zip ? data.zip : "";
    addressField = street + route + city + state + zip;
    let finalValue = addressField === "" ? "No address supplied" : addressField;
    return finalValue;
  };
  render() {
    const { classes, data, history, name, withFooter = true } = this.props;
    const { lat, lng } = data;
    const zoom = 12;
    const windowWidth = window.innerWidth;

    const size = `${windowWidth - 30}x100`;

    const mapsStaticURL = "https://maps.googleapis.com/maps/api/staticmap?";
    const mapStyle = `feature:all|element:labels|visibility:simplified&style=feature:all|element:labels.text|color:0x444444&style=feature:administrative.country|element:all|visibility:simplified&style=feature:administrative.country|element:geometry|visibility:simplified&style=feature:administrative.province|element:all|visibility:off&style=feature:administrative.locality|element:all|visibility:simplified|saturation:-100|lightness:30&style=feature:administrative.neighborhood|element:all|visibility:off&style=feature:administrative.land_parcel|element:all|visibility:off&style=feature:landscape|element:all|visibility:simplified|gamma:0.00|lightness:74&style=feature:landscape|element:geometry|color:0xffffff&style=feature:poi|element:all|visibility:off&style=feature:road|element:geometry|visibility:simplified|color:0xff0000|saturation:-15|lightness:40|gamma:1.25&style=feature:road|element:labels|visibility:off&style=feature:transit|element:labels|visibility:simplified&style=feature:transit|element:labels.icon|visibility:off&style=feature:transit.line|element:geometry|color:0xff0000|lightness:80&style=feature:transit.station|element:geometry|color:0xe5e5e5&style=feature:water|element:geometry|color:0xefefef&style=feature:water|element:labels|visibility:off`;

    // TODO MAKE COMPONENT FOR LATER
    const mapURL = `${mapsStaticURL}center=${lat},${lng}&zoom=${zoom}&size=${size}&markers=${lat},${lng}&key=${process.env.REACT_APP_GOOGLE_GEOENCODING_API_KEY}&style=${mapStyle}`;

    console.log("data", data);
    console.log(mapURL, "mapURL");
    return (
      <React.Fragment>
        <Card className={classes.cardWrapper}>
          <div className={classes.headerBox} style={{ height: "100px" }}>
            <img
              src={mapURL}
              alt="map"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
          {withFooter ? (
            <CardActions className={classes.footerBox}>
              <div className={classes.footerBoxText}>
                <Typography
                  variant="body1"
                  // className={classes.name}
                >
                  {data.attendees && data.attendees.length === 1
                    ? `${data.attendees[0].first_name !== null ? data.attendees[0].first_name : ''}
                     ${data.attendees[0].last_name !== null ? data.attendees[0].last_name : ''}`
                    : data.attendees && data.attendees.length > 1
                    ? "Multiple clients"
                    : "No client"}
                </Typography>
                <Typography
                  variant="body2"
                  // className={classes.address}
                >
                  {/* // TODO remove id */}
                  {this.address(data)}
                </Typography>
              </div>

              <Button
                variant="contained"
                className={classes.button}
                onClick={() => {
                  // TODO change route
                  // history.push("/showings/done/" + data.id);
                  history.push({
                    pathname: `/showings/done/${data.id}`,
                    state: data
                  })
                }}
              >
                {name ? name : "VIEW"}
              </Button>
            </CardActions>
          ) : null}
        </Card>
      </React.Fragment>
    );
  }
}

const mapStateToProps = () => {
  return {};
};
const mapActionsToProps = () => {
  return {};
};

export default compose(
  connect(mapStateToProps, mapActionsToProps),
  withStyles(styles)
)(ShowingCard);
